import { ActionIcon as MantineActionIcon } from '@mantine/core'

import { root } from './ActionIcon.css'

export const ActionIcon = MantineActionIcon.extend({
  classNames: { root }
})
